<template>
  <div class="events-basic-information">
    <div class="row gap-3">
      <div class="col-lg-4">
        <snow-input-file
          v-model="form.picture"
          is-image
          dimensions="256 x 256"
          title="Imagem do produto"
        />
      </div>
      <div class="col bg-2 p-4 rounded-16">
        <snow-input
          v-model="form.name"
          class="mb-6"
          label="Nome do evento *"
          :rules="rules.name"
        />
        <snow-input
          v-model="form.description"
          :rows="3"
          type="textarea"
          class="mb-6"
          label="Descrição *"
          :rules="rules.description"
        />
        <h5 class="text-semibold">Localização</h5>
        <div class="row mb-7 mt-4">
          <div class="col-lg-6 mb-6 mb-lg-0">
            <snow-input
              v-model="form.event_location"
              label="Local *"
              :rules="rules.event_location"
            />
          </div>
          <div class="col-lg-6">
            <snow-input
              v-model="form.event_address"
              label="Endereço do local *"
              :rules="rules.event_address"
            />
          </div>
        </div>
        <h5 class="text-semibold">Definir período do evento</h5>
        <div class="row mb-6 mt-2">
          <div class="col-lg-6 mb-lg-0">
            <form-group
              v-model="form.event_start_at"
              is-date
              readonly
              required
              mode="dateTime"
              id="start-date"
              with-clear-button
              placeholder="Início do evento *"
              :min-date="new Date()"
            />
          </div>
          <div class="col-lg-6">
            <form-group
              v-model="form.event_end_at"
              is-date
              readonly
              required
              mode="dateTime"
              id="start-date"
              with-clear-button
              placeholder="Término do evento *"
              :min-date="minEndDate"
            />
          </div>
        </div>
        <action-dispatcher action="product/getCategories">
          <snow-select
            v-model="form.category_id"
            required
            label="Categoria do evento"
            :options="categories"
          />
        </action-dispatcher>
      </div>
    </div>
  </div>
</template>
<script>
import { toComputerDate } from "@/functions/helpers";
import { mapState } from "vuex";

import { maxLength, required } from "@/functions/validation";

export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      rules: {
        name: [required(), maxLength(64)],
        description: [required(), maxLength(980)],
        event_location: [required()],
        event_address: [required()],
        event_start_at: [required()],
        event_end_at: [required()]
      }
    };
  },
  computed: {
    ...mapState("product", ["categories"]),
    minEndDate() {
      if (this.form.event_start_at)
        return new Date(toComputerDate(this.form.event_start_at));

      return new Date();
    }
  },
  watch: {
    "form.event_start_at"(v) {
      if (
        this.form.event_end_at &&
        new Date(toComputerDate(v)) >
          new Date(toComputerDate(this.form.event_end_at))
      ) {
        this.$emit("reset-end-date");
      }
    }
  }
};
</script>
